<template>
  <div class="min-h-screen bg-background text-text">
    <div class="container mx-auto px-4 py-10">
      <div v-if="loading" class="rounded-2xl border border-gold/20 bg-backgroundLight p-6 text-secondary">
        Chargement du profil...
      </div>

      <div v-else-if="profile" class="mx-auto max-w-4xl rounded-3xl border border-gold/20 bg-backgroundLight p-6 shadow-glow-gold">
        <div class="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <p class="text-xs uppercase tracking-[0.22em] text-gold font-semibold">Profil public</p>
            <h1 class="mt-2 text-3xl font-bold text-primary">{{ profile.username }}</h1>
            <div class="mt-3 flex flex-wrap gap-2 text-sm text-secondary">
              <span v-if="profile.city" class="rounded-full border border-gold/20 bg-background px-3 py-1">{{ profile.city.name }}</span>
              <span v-if="profile.department" class="rounded-full border border-gold/20 bg-background px-3 py-1">{{ profile.department.name }}</span>
              <span v-if="profile.region" class="rounded-full border border-gold/20 bg-background px-3 py-1">{{ profile.region.name }}</span>
            </div>
          </div>

          <div class="rounded-2xl border border-gold/20 bg-background p-4 text-center">
            <p class="text-[10px] uppercase tracking-[0.18em] text-secondary">Valeur</p>
            <p class="mt-2 text-2xl font-bold text-gold">{{ formatAmount(profile.amount) }}</p>
          </div>
        </div>

        <div class="mt-8 grid gap-6 md:grid-cols-[1.3fr_0.7fr]">
          <div class="rounded-2xl border border-gold/20 bg-background p-5">
            <h2 class="text-lg font-bold text-primary">Présentation</h2>
            <p class="mt-3 text-secondary leading-relaxed">
              {{ profile.bio || 'Cette personne n’a pas encore ajouté de bio.' }}
            </p>
          </div>

          <div class="rounded-2xl border border-gold/20 bg-background p-5 space-y-4">
            <div>
              <p class="text-[10px] uppercase tracking-[0.18em] text-secondary">Rang</p>
              <p class="mt-2 text-xl font-bold text-gold">Top local</p>
            </div>
            <div>
              <p class="text-[10px] uppercase tracking-[0.18em] text-secondary">Activité</p>
              <p class="mt-2 text-sm text-secondary">Actif récemment</p>
            </div>
            <button type="button" class="btn-gold w-full" @click="messageUser">
              Envoyer un message
            </button>
          </div>
        </div>
      </div>

      <div v-else class="rounded-2xl border border-red-500/30 bg-red-500/5 p-6 text-red-300">
        Profil introuvable.
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserService from '@/services/user.service'

const route = useRoute()
const router = useRouter()
const profile = ref(null)
const loading = ref(true)

async function loadProfile() {
  try {
    loading.value = true
    const userId = route.params.userId
    const data = await UserService.getPublicProfile(userId)
    profile.value = data
  } catch (error) {
    console.error('Erreur chargement profil public', error)
    profile.value = null
  } finally {
    loading.value = false
  }
}

function formatAmount(value) {
  const amount = Number(value || 0)
  return `${amount.toLocaleString('fr-FR')} €`
}

function messageUser() {
  router.push({ name: 'DirectMessages' })
}

onMounted(() => {
  loadProfile()
})
</script>
